import { render, staticRenderFns } from "./AccountRole.vue?vue&type=template&id=e46f625c&"
import script from "./AccountRole.vue?vue&type=script&lang=js&"
export * from "./AccountRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports